import React from 'react';
import {
    Document,
    Page,
    View,
    Text,
    StyleSheet,
    Image,
} from '@react-pdf/renderer';

import moment from 'moment';
moment.locale('es');

const styles = StyleSheet.create({
    page: {
        fontWeight: 100,
        backgroundColor: '#fff',
        paddingTop: 10,
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '80%',
    },
    heading: {
        fontWeight: 100,
        backgroundColor: '#fff',
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        fontSize: 24,
        fontWeight: 400,
    },
    caption: {
        fontSize: 14,
        fontWeight: 300,
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        padding: 10,
        borderBottom: '1px solid #E0E0E0',
    },
    header: {
        width: 150,
        fontWeight: 'bold',
        fontSize: 10,
    },
    text: {
        fontSize: 10,
        textTransform: 'capitalize',
    },
    table: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        border: '1px solid #E0E0E0',
        borderRadius: 3,
        padding: 20,
        margin: 20,
    },
    signature: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
        padding: 10,
        marginTop: 20,
    },
    signatureText: {
        fontSize: 10,
        fontWeight: 'bold',
    },
    copy: {
        fontSize: 8,
        lineHeight: 1.3,
        textAlign: 'justify',
        textJustify: 'inner-word',
        color: '#757575',
    },
    dateCaption: {
        marginTop: 10,
        fontSize: 10,
        fontWeight: 'bold',
    },
});

export const PDFFile = ({ values }) => {
    const {
        primerNombre,
        segundoNombre,
        apellidoPaterno,
        apellidoMaterno,
        email,
        fechaNacimiento,
        direccion1,
        coloniaPoblacion,
        delegacionMunicipio,
        ciudad,
        estado,
        cp,
        RFC,
        sign,
    } = values;

    return (
        <Document>
            <Page size="A4">
                <View style={styles.heading}>
                    <Text style={styles.title}>
                        Solicitud de Score - Carokou México
                    </Text>
                    <Text style={styles.caption}>
                        Solicitud de para consulta de score de buró de crédito
                    </Text>
                    <Text style={styles.dateCaption}>
                        A{' '}
                        {moment().format(
                            'DD [de] MMMM [del] YYYY [-] HH:mm:ss a'
                        )}
                        , {ciudad}, {estado}
                    </Text>
                </View>
                <View style={styles.table}>
                    <View style={styles.row}>
                        <Text style={styles.header}>Nombre</Text>
                        <Text style={styles.text}>
                            {primerNombre} {segundoNombre} {apellidoPaterno}{' '}
                            {apellidoMaterno}
                        </Text>
                    </View>
                    <View style={styles.row}>
                        <Text style={styles.header}>Correo</Text>
                        <Text style={styles.text}>{email}</Text>
                    </View>
                    <View style={styles.row}>
                        <Text style={styles.header}>Fecha de nacimiento</Text>
                        <Text style={styles.text}>
                            {moment(fechaNacimiento).format(
                                'DD [de] MMMM [del] YYYY'
                            )}
                        </Text>
                    </View>
                    <View style={styles.row}>
                        <Text style={styles.header}>Domicilio</Text>
                        <Text style={styles.text}>
                            {direccion1} {coloniaPoblacion},{' '}
                            {delegacionMunicipio}, {ciudad}, {estado}, CP: {cp}
                        </Text>
                    </View>
                    <View style={styles.row}>
                        <Text style={styles.header}>RFC</Text>
                        <Text style={styles.text}>{RFC}</Text>
                    </View>
                    <View style={styles.signature}>
                        <Image src={sign} style={{ width: 300, height: 100 }} />
                        <Text style={styles.signatureText}>
                            Firma de Autorización
                        </Text>
                    </View>
                    <Text style={styles.copy}>
                        Por este conducto autorizo expresamente a CAROKOU MEXICO
                        SAPI DE CV, para que por conducto de sus funcionarios
                        facultados lleve a cabo Investigaciones, sobre mi
                        comportamiento crediticio o el de la Empresa que
                        represento, declaro que conozco la naturaleza y alcance
                        de la información que se solicitará, del uso que CAROKOU
                        MEXICO SAPI DE CV, hará de tal información y de que ésta
                        podrá realizar consultas periódicas sobre mi historial o
                        el de la empresa que represento, consintiendo que esta
                        autorización se encuentre vigente por un período de 3
                        años contados a partir de su expedición y en todo caso
                        durante el tiempo que se mantenga la relación juridica.
                    </Text>
                </View>
            </Page>
        </Document>
    );
};
